module.exports = __webpack_public_path__ + "img/header.3efe9763.svg";